'use client';

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Syncs the <html lang> attribute with the current i18n language.
 * In Next.js App Router, the root layout's <html lang> is set server-side
 * and does not update on client-side language changes. This component
 * ensures WCAG 3.1.1 (Language of Page) compliance by updating the
 * attribute whenever the language changes.
 */
export const LanguageSync = (): null => {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return null;
};
